'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _analytics = require('../../redux/modules/analytics');

var _user = require('../../redux/modules/user');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeskPopup = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        fullStorySessionUrl: (0, _analytics.getFullStorySessionUrl)(state),
        userData: (0, _user.getUserData)(state)
    };
}), _dec(_class = function (_PureComponent) {
    (0, _inherits3.default)(DeskPopup, _PureComponent);

    function DeskPopup() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DeskPopup);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeskPopup.__proto__ || (0, _getPrototypeOf2.default)(DeskPopup)).call.apply(_ref, [this].concat(args))), _this), _this.formLinkClick = function () {
            var _this$props = _this.props,
                fullStorySessionUrl = _this$props.fullStorySessionUrl,
                userData = _this$props.userData;
            var email = userData.email,
                firstName = userData.firstName,
                lastName = userData.lastName;

            var emailToUse = email || '';
            var nameToUse = firstName || lastName ? (firstName + ' ' + lastName).trim() : '';

            var fields = [];
            nameToUse && fields.push('interaction[name]=' + encodeURIComponent(nameToUse));
            emailToUse && fields.push('interaction[email]=' + emailToUse);
            fields.push('email[subject]=' + encodeURIComponent('Website Feedback'));
            fields.push('ticket[labels_new]=' + encodeURIComponent('Qualaroo Feedback'));
            fullStorySessionUrl && fields.push('ticket[custom_fullstory]=' + encodeURIComponent(fullStorySessionUrl));

            var url = 'https://liveauctioneers.desk.com/customer/widget/emails/new' + (fields.length ? '?' + fields.join('&') : '');

            document.getElementsByTagName('body')[0].classList.add('body-modal-open');
            document.getElementById('desk-form').src = url;
            document.getElementById('desk-form-overlay').style.display = 'block';
            document.getElementById('desk-form-container').style.display = 'block';
            document.getElementById('desk-form-link-container').style.display = 'none';
            return false;
        }, _this.formCloseClick = function () {
            document.getElementsByTagName('body')[0].classList.remove('body-modal-open');
            document.getElementById('desk-form').src = '';
            document.getElementById('desk-form-overlay').style.display = 'none';
            document.getElementById('desk-form-container').style.display = 'none';
            document.getElementById('desk-form-link-container').style.display = 'block';
            return false;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DeskPopup, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {
                className: 'form-overlay',
                id: 'desk-form-overlay'
            }), (0, _jsx3.default)('div', {
                className: 'form-container',
                id: 'desk-form-container'
            }, void 0, (0, _jsx3.default)('a', {
                className: 'form-close',
                href: '#',
                onClick: this.formCloseClick
            }, void 0, '\xD7'), (0, _jsx3.default)('iframe', {
                className: 'form',
                frameBorder: '0',
                id: 'desk-form'
            })), (0, _jsx3.default)('div', {
                className: 'form-link-container',
                id: 'desk-form-link-container'
            }, void 0, (0, _jsx3.default)('a', {
                className: 'form-link',
                href: '#',
                onClick: this.formLinkClick
            }, void 0, 'Feedback')));
        }
    }]);
    return DeskPopup;
}(_react.PureComponent)) || _class);
exports.default = DeskPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeskPopup/DeskPopup.js
// module id = lHUE
// module chunks = 57